import React from 'react';
import { bool } from 'prop-types';
import Shimmer from '@airasia/phoenix-components/components/Shimmer';
import styled, { keyframes } from 'styled-components';
import Column from '../Container/Column';
import Row from '../Container/Row';
import Wrapper from '../Wrapper';
import { CardContent, TemplateCard } from '../Card/TemplateCard';

const ShimmerHotelCard = ({ isMobileView, override, isRecommendedHotel }) => {
  const keyFrameExampleOne = keyframes`
   0%{
        background-position: -668px 0
    }
    100%{
        background-position: 668px 0
    }
`;
  const ShimmerComponent = styled.div`
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: ${keyFrameExampleOne};
    animation-timing-function: linear;
    background: #f6f7f8;
    border: 0;
    border: 0px;
    background: linear-gradient(
      to right,
      #f6f7f8 0%,
      #edeef1 20%,
      #f6f7f8 40%,
      #f6f7f8 100%
    );
    background-size: 100% 100%;
    position: relative;
  `;
  const leftContentComponent = isMobileView ? (
    <Column>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" width="128px" height="12px" />
      </Wrapper>
      <Row mt={4} alignItems="center">
        <Wrapper>
          <Shimmer borderRadius="2px" width="40px" height="16px" />
        </Wrapper>
        <Wrapper ml={1}>
          <Shimmer borderRadius="2px" width="68px" height="12px" />
        </Wrapper>
      </Row>
    </Column>
  ) : (
    <Column>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" width="296px" height="12px" />
      </Wrapper>
      <Wrapper mt={3}>
        <Shimmer borderRadius="2px" width="96px" height="12px" />
      </Wrapper>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" width="128px" height="12px" />
      </Wrapper>
      <Wrapper mt={4}>
        <Shimmer borderRadius="2px" width="188px" height="12px" />
      </Wrapper>
    </Column>
  );

  const rightContentComponent = isMobileView ? (
    <Column alignItems="flex-end">
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" width="68px" height="12px" />
      </Wrapper>
      <Wrapper mt={3}>
        <Shimmer borderRadius="2px" width="40px" height="12px" />
      </Wrapper>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" width="75px" height="20px" />
      </Wrapper>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" width="88px" height="12px" />
      </Wrapper>
    </Column>
  ) : (
    <Column alignItems="flex-end">
      <Wrapper>
        <Shimmer borderRadius="2px" width="78px" height="20px" />
      </Wrapper>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" width="137px" height="12px" />
      </Wrapper>
    </Column>
  );

  const headerComponent = isMobileView ? (
    <Column>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" height="12px" />
      </Wrapper>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" height="12px" />
      </Wrapper>
      <Wrapper mt={2}>
        <Shimmer borderRadius="2px" width="96px" height="12px" />
      </Wrapper>
    </Column>
  ) : (
    <></>
  );
  return (
    <ShimmerComponent>
      <TemplateCard
        override={override}
        isRecommendedHotel={isRecommendedHotel}
        headerComponent={headerComponent}
      >
        <CardContent
          leftContentComponent={leftContentComponent}
          rightContentComponent={rightContentComponent}
          isRecommendedHotel={isRecommendedHotel}
          override={override}
        />
      </TemplateCard>
    </ShimmerComponent>
  );
};

ShimmerHotelCard.propTypes = {
  isMobileView: bool,
  override: bool,
  isRecommendedHotel: bool,
};

export default ShimmerHotelCard;
